export default __webpack_public_path__ + "static/media/privacy.8eb7924a.jpg";